import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  id: () => `role_${faker.string.alphanumeric(8)}`,
  name: () => faker.person.jobTitle(),
  permissions: () => [],
  type: 'custom',
});
